var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 155,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5DED5",
    d: "M5 77.5a77.5 77.5 0 1 0 155.001 0A77.5 77.5 0 0 0 5 77.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1C62EB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M10.724 81.12a51.199 51.199 0 1 0 87.343-53.447A51.199 51.199 0 0 0 10.724 81.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFF",
    d: "M17 54a37 37 0 1 0 74 0 37 37 0 0 0-74 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C62EB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M33 69.72a24.647 24.647 0 0 1 8.99-9.196 23.797 23.797 0 0 1 12.275-3.288A23.814 23.814 0 0 1 66.48 60.75a24.682 24.682 0 0 1 8.829 9.36M37.292 37l9.811 8.584M37.292 45.584 47.103 37M58.753 37l9.81 8.584M58.753 45.584 68.563 37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C62EB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M80.168 27.842a37 37 0 1 1-52.335 52.315 37 37 0 0 1 52.335-52.315Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFF",
    d: "m143.076 139.849-.462.463a9.985 9.985 0 0 1-14.069 0l-30.58-30.598a3.327 3.327 0 0 1 0-4.689l9.842-9.846a3.325 3.325 0 0 1 4.69 0l30.579 30.594a9.93 9.93 0 0 1 0 14.076Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1C62EB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M107 95.564 96.015 84.211A51.277 51.277 0 0 1 87 94.181l10.668 11.03L107 95.564Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C62EB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m143.076 139.849-.462.463a9.985 9.985 0 0 1-14.069 0l-30.58-30.598a3.327 3.327 0 0 1 0-4.689l9.842-9.846a3.325 3.325 0 0 1 4.69 0l30.579 30.594a9.93 9.93 0 0 1 0 14.076Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h164v155H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.aeb7d7f56206d87f65e9b7319ef4fd2a.svg";